"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eeZones = void 0;
var eeZones = exports.eeZones = [{
  id: 'TALLINN',
  name: 'Tallinn',
  country: 'EE',
  cornerNW: {
    latitude: 59.4713,
    longitude: 24.5938
  },
  cornerSE: {
    latitude: 59.3901,
    longitude: 24.8445
  },
  subZones: [{
    name: 'Tallinna Vanalinn',
    zipcodes: {
      10120: {
        label: '10120'
      }
    }
  }, {
    name: 'Tallinna Kesklinn',
    zipcodes: {
      10152: {
        label: '10152'
      }
    }
  }, {
    name: 'Tallinna Mustamäe',
    zipcodes: {
      11415: {
        label: '11415'
      }
    }
  }, {
    name: 'Tallinna Lasnamäe',
    zipcodes: {
      13619: {
        label: '13619'
      }
    }
  }]
}];